<template>
  <v-dialog v-model="internalDialog" persistent class="mx-auto" fullscreen scrollable>
    <v-card class="glassmorphism-card" style="border-radius: 0px 0px 0 0; background: rgba(255, 255, 255, 0.25); 
      backdrop-filter: blur(20px); border: 1px solid rgba(255, 255, 255, 0.3);">
      <div class="pa-8">
        <!-- Handle Bar -->
        <!-- <div class="handle-bar"></div> -->

        <!-- Icon Container -->
        <div class="icon-container">
          <v-icon size="32" color="white">mdi-book-open-page-variant</v-icon>
        </div>

        <!-- Content -->
        <div class="text-center mb-8">
          <h2 class="glass-title">Fè lekti tounen pastan w</h2>
          <p class="glass-subtitle">Enskri gratis</p>
        </div>

        <!-- Buttons -->
        <div class="d-flex flex-column ga-3 mb-6">

          <v-btn @click="handleSignIn('google')" class="premium-btn-primary" size="large" rounded="xl"
            :loading="loadingGoogle" :disabled="loadingGoogle">
            <v-icon start>mdi-google</v-icon>
            {{ loadingGoogle ? 'Koneksyon...' : 'Kontinye ak Google' }}
          </v-btn>

          <v-btn @click="handleSignIn('email')" class="premium-btn-secondary" size="large" rounded="xl"
            variant="outlined">
            <v-icon start>mdi-email</v-icon>
            Imel ak modpas
          </v-btn>
        </div>

        <!-- Checkbox -->
        <div class="d-flex align-start ga-3">
          <v-checkbox v-model="check" color="orange" hide-details></v-checkbox>
          <div class="glass-terms">
            Mwen aksepte <span @click="navigateTo('/PolitiqueUserPage')" class="terms-link">Politik
              Konfidansyalite</span>
            ak <span @click="navigateTo('/ConditionUserPage')" class="terms-link">Kondisyon itilizasyon</span> Dous
            Literè.
          </div>
        </div>

        <span v-if="showError" class="text-danger mt-2 text-wrap text-center">
          Ou dwe aksepte politik Konfidansyalite ak kondisyon itilizasyon Dous Literè pou w enskri oubyen konekte
        </span>
      </div>

      <v-btn class="mx-auto text-none" rounded="pill" variant="tonal" @click="goTo()">Fèmen</v-btn>
    </v-card>

    <!-- Ajouter dans le template, juste avant la fermeture du premier v-dialog -->
    <!-- <v-overlay v-model="loadingGoogle" persistent class="align-center justify-center">
      <div class="text-center">
        <v-progress-circular color="orange" indeterminate size="64" width="6"></v-progress-circular>
        <p class="mt-4 text-white font-weight-bold">Koneksyon ak Google...</p>
        <p class="text-white text-body-2">Tanpri tann...</p>
      </div>
    </v-overlay> -->
  </v-dialog>


  <v-dialog v-model="signWithEmail" persistent fullscreen scrollable>
    <v-card class="glassmorphism-dialog">
      <!-- Close Button -->
      <div class="d-flex justify-start pa-4 pb-0">
        <v-btn @click="closeDialog" class="glassmorphism-close-btn" icon size="40">
          <v-icon color="white">mdi-close</v-icon>
        </v-btn>
      </div>

      <v-card-text class="glassmorphism-content">
        <!-- Login Form -->
        <v-form v-if="isLogin" @submit.prevent="login" class="glassmorphism-form">
          <h2 class="glassmorphism-title">Koneksyon</h2>

          <div class="glassmorphism-fields">
            <!-- Email Field -->
            <div class="glassmorphism-field-group">
              <label class="glassmorphism-label">Imel*</label>
              <div class="glassmorphism-input-container">
                <input v-model="email" type="email" placeholder="Imel*" class="glassmorphism-input" autocomplete="email"
                  required />
                <span v-if="email" @click="email = ''" class="glassmorphism-clear-btn">×</span>
                <div class="glassmorphism-input-icon">
                  <v-icon color="rgba(255, 255, 255, 0.7)">mdi-email</v-icon>
                </div>
              </div>
            </div>

            <!-- Password Field -->
            <div class="glassmorphism-field-group">
              <label class="glassmorphism-label">Modpas*</label>
              <div class="glassmorphism-input-container">
                <input v-model="password" :type="visible ? 'text' : 'password'" placeholder="Modpas*"
                  class="glassmorphism-input" autocomplete="current-password" required />
                <span v-if="password" @click="password = ''" class="glassmorphism-clear-btn">×</span>
                <button type="button" @click="visible = !visible" class="glassmorphism-visibility-btn">
                  <v-icon :color="visible ? 'rgba(255, 255, 255, 0.7)' : 'rgba(255, 255, 255, 0.5)'">
                    {{ visible ? 'mdi-eye-off' : 'mdi-eye' }}
                  </v-icon>
                </button>
              </div>
            </div>

            <!-- Error Message -->
            <p v-if="errMsg" class="glassmorphism-error">{{ errMsg }}</p>

            <!-- Login Button -->
            <v-btn @click="login" class="glassmorphism-btn-primary" size="large" block rounded="xl" :loading="loading2">
              Konekte
            </v-btn>

            <!-- Forgot Password Link -->
            <p @click="navigateTo('/ForgotPasswordPage')" class="glassmorphism-link">
              Ou bliye modpas ou? Klike la
            </p>

            <!-- New Password Button -->
            <v-btn @click="navigateTo('/ForgotPasswordPage')" class="glassmorphism-btn-secondary" size="large" block
              rounded="xl">
              Nouvo Modpas
            </v-btn>

            <!-- Register Link -->
            <p @click="switchToRegister" class="glassmorphism-link">
              Ou poko enskri? Klike la
            </p>

            <!-- Register Button -->
            <v-btn @click="switchToRegister" class="glassmorphism-btn-tertiary" size="large" block rounded="xl">
              Enskri
            </v-btn>
          </div>
        </v-form>

        <!-- Register Form -->
        <v-form v-if="!isLogin" @submit.prevent="register" class="glassmorphism-form">
          <h2 class="glassmorphism-title">Enskripsyon</h2>

          <div class="glassmorphism-fields">
            <!-- Siyati Field -->
            <div class="glassmorphism-field-group">
              <label class="glassmorphism-label">Siyati*</label>
              <div class="glassmorphism-input-container">
                <input v-model="siyati" type="text" placeholder="Siyati*" class="glassmorphism-input"
                  autocomplete="text" required />
                <span v-if="siyati" @click="siyati = ''" class="glassmorphism-clear-btn">×</span>
                <div class="glassmorphism-input-icon">
                  <v-icon color="rgba(255, 255, 255, 0.7)">mdi-account</v-icon>
                </div>
              </div>
            </div>

            <!-- Non Field -->
            <div class="glassmorphism-field-group">
              <label class="glassmorphism-label">Non*</label>
              <div class="glassmorphism-input-container">
                <input v-model="non" type="text" placeholder="Non*" class="glassmorphism-input" autocomplete="text"
                  required />
                <span v-if="non" @click="non = ''" class="glassmorphism-clear-btn">×</span>
                <div class="glassmorphism-input-icon">
                  <v-icon color="rgba(255, 255, 255, 0.7)">mdi-account</v-icon>
                </div>
              </div>
            </div>

            <!-- Email Field -->
            <div class="glassmorphism-field-group">
              <label class="glassmorphism-label">Imel*</label>
              <div class="glassmorphism-input-container">
                <input v-model="email" type="email" placeholder="Imel*" class="glassmorphism-input" autocomplete="email"
                  required />
                <span v-if="email" @click="email = ''" class="glassmorphism-clear-btn">×</span>
                <div class="glassmorphism-input-icon">
                  <v-icon color="rgba(255, 255, 255, 0.7)">mdi-email</v-icon>
                </div>
              </div>
            </div>

            <!-- Password Field -->
            <div class="glassmorphism-field-group">
              <label class="glassmorphism-label">Modpas*</label>
              <div class="glassmorphism-input-container">
                <input v-model="password" :type="visible ? 'text' : 'password'" placeholder="Modpas*"
                  class="glassmorphism-input" autocomplete="current-password" required />
                <span v-if="password" @click="password = ''" class="glassmorphism-clear-btn">×</span>
                <button type="button" @click="visible = !visible" class="glassmorphism-visibility-btn">
                  <v-icon :color="visible ? 'rgba(255, 255, 255, 0.7)' : 'rgba(255, 255, 255, 0.5)'">
                    {{ visible ? 'mdi-eye-off' : 'mdi-eye' }}
                  </v-icon>
                </button>
              </div>
            </div>

            <!-- Confirm Password Field -->
            <div class="glassmorphism-field-group">
              <label class="glassmorphism-label">Konfime modpas*</label>
              <div class="glassmorphism-input-container">
                <input v-model="confirmPassword" :type="visible ? 'text' : 'password'" placeholder="Konfime modpas*"
                  class="glassmorphism-input" autocomplete="current-password" required />
                <span v-if="confirmPassword" @click="confirmPassword = ''" class="glassmorphism-clear-btn">×</span>
                <button type="button" @click="visible = !visible" class="glassmorphism-visibility-btn">
                  <v-icon :color="visible ? 'rgba(255, 255, 255, 0.7)' : 'rgba(255, 255, 255, 0.5)'">
                    {{ visible ? 'mdi-eye-off' : 'mdi-eye' }}
                  </v-icon>
                </button>
              </div>
            </div>

            <!-- Registration Error Message -->
            <p v-if="registrationMessage" class="glassmorphism-error">{{ registrationMessage }}</p>

            <!-- Register Button -->
            <v-btn @click="register" class="glassmorphism-btn-primary" size="large" block rounded="xl"
              :loading="loading3">
              Enskri
            </v-btn>

            <!-- Login Link -->
            <p class="glassmorphism-link-text">Ou enskri deja?</p>

            <!-- Login Button -->
            <v-btn @click="switchToLogin" class="glassmorphism-btn-secondary" size="large" block rounded="xl">
              Konekte
            </v-btn>
          </div>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, watch } from "vue";
// import { Plugins } from '@capacitor/core';
import { GoogleAuth } from '@codetrix-studio/capacitor-google-auth';
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
// 1. D'abord, ajoutez ces imports en haut de votre script
import { Device } from '@capacitor/device';
// import { GoogleAuth } from '@codetrix-studio/capacitor-google-auth';
import {
  getAuth, signInWithEmailAndPassword, createUserWithEmailAndPassword,
  GoogleAuthProvider,
  signInWithPopup,
  signInWithCredential
} from "firebase/auth";
import { useRouter } from 'vue-router';
import { defineProps, defineEmits } from 'vue';
import { db } from "@/main"; // Importez `db` depuis le fichier main.js

import {collection, setDoc, doc, serverTimestamp, getDoc, updateDoc, where, getDocs, query } from 'firebase/firestore';

// Props et évenements
const props = defineProps({
  dialog: {
    type: Boolean,
    required: true,
  },
   dialog2: {
    type: Boolean,
   required: false, // Changez en 'false' si elle n'est pas toujours nécessaire
    default: false // Ajoutez une valeur par défaut pour éviter l'erreur
  }
});
const emit = defineEmits(['update:dialog', 'update:dialog2']);

// Fonction pour obtenir un ID unique du device
const getDeviceId = async () => {
  try {
    if (Capacitor.isNativePlatform()) {
      const info = await Device.getId();
      return info.identifier; // ID unique du device
    } else {
      // Pour le web, créer un fingerprint basé sur les caractéristiques du navigateur
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      ctx.textBaseline = 'top';
      ctx.font = '14px Arial';
      ctx.fillText('Device fingerprint', 2, 2);

      const fingerprint = canvas.toDataURL() +
        navigator.userAgent +
        navigator.language +
        screen.width + 'x' + screen.height +
        new Date().getTimezoneOffset();

      // Créer un hash simple
      let hash = 0;
      for (let i = 0; i < fingerprint.length; i++) {
        const char = fingerprint.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash = hash & hash; // Convertir en 32bit integer
      }
      return Math.abs(hash).toString();
    }
  } catch (error) {
    // console.error('Erreur lors de la récupération de l\'ID du device:', error);
    return 'unknown-device-' + Date.now();
  }
};

// Fonction pour obtenir le pays de l'utilisateur
const getUserCountry = async () => {
  try {
    // Méthode 1: Via l'API de géolocalisation (plus précise mais demande permission)
    if (navigator.geolocation) {
      return new Promise((resolve) => {
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            try {
              // Utiliser un service de géocodage inverse pour obtenir le pays
              const response = await fetch(
                `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${position.coords.latitude}&longitude=${position.coords.longitude}&localityLanguage=en`
              );
              const data = await response.json();
              resolve(data.countryName || await getFallbackCountry());
            } catch (error) {
              resolve(await getFallbackCountry());
            }
          },
          async () => {
            // Si l'utilisateur refuse la géolocalisation
            resolve(await getFallbackCountry());
          },
          { timeout: 5000 }
        );
      });
    } else {
      return await getFallbackCountry();
    }
  } catch (error) {
    // console.error('Erreur lors de la détection du pays:', error);
    return await getFallbackCountry();
  }
};

// Fonction de fallback pour obtenir le pays via IP
const getFallbackCountry = async () => {
  try {
    // Méthode 2: Via l'adresse IP (ne demande pas de permission)
    const response = await fetch('https://ipapi.co/json/');
    const data = await response.json();
    return data.country_name || 'Inconnu';
  } catch (error) {
    // Méthode 3: Via le timezone du navigateur (moins précis)
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const countryFromTimezone = timezone.split('/')[0];
    return countryFromTimezone || 'Inconnu';
  }
};

// Variables d'état
const email = ref("");
const password = ref("");
const confirmPassword = ref("");
const siyati = ref("");
const non = ref("");
const errMsg = ref("");
const registrationMessage = ref("");
const visible = ref(false);
const internalDialog = ref(props.dialog);
const signWithEmail = ref(props.dialog2);
const isLogin = ref(true);
const router = useRouter();
const check= ref(false);
const showError= ref(false);
const loading = ref(false);
const loading2 = ref(false);
const loading3 = ref(false);
// Ajouter cette variable dans vos variables d'état
const loadingGoogle = ref(false);

const handleSignIn = (method) => {
  if (!check.value) {
    showError.value = true;
    return;
  }

  showError.value = false;

  if (method === "google") {
    signInWithGoogle(); // Le loading sera géré dans cette fonction
  } else if (method === "email") {
    internalDialog.value = false;
    setTimeout(() => {
      signWithEmail.value = true;
    }, 300);
  }
};

// Règles de validation
const rules = {
  required: value => !!value || 'Chan sa yo pa dwe vid',
  min: (v) => v.length >= 8 || 'Modpas la dwe gen omwen 8 karaktè.',
  emailMatch: () => 'Imel ak modpas ou antre yo pa matche.',
};

// Watchers
watch(() => props.dialog, (val) => {
  internalDialog.value = val;
});
watch(internalDialog, (val) => {
  emit('update:dialog', val);
});

watch(() => props.dialog2, (val) => {
  signWithEmail.value = val;
});
watch(signWithEmail, (val) => {
  emit('update:dialog2', val);
});
// Méthodes
const closeDialog = () => {
  email.value = ''; // Cacher l'erreur si la case est cochée
  password.value = ''; // Cacher l'erreur si la case est cochée
  siyati.value = ''; // Cacher l'erreur si la case est cochée
  non.value = ''; // Cacher l'erreur si la case est cochée
  confirmPassword.value = ''; // Cacher l'erreur si la case est cochée
  signWithEmail.value = false;
  internalDialog.value = false;

  if (window.AndroidFullScreen && typeof window.AndroidFullScreen.showSystemUI === 'function') {
    window.AndroidFullScreen.showSystemUI();
  }

  if (Capacitor.getPlatform() !== 'web') {
    StatusBar.setStyle({ style: Style.Light });
    StatusBar.setBackgroundColor({ color: '#ffffff' });
    // StatusBar.show();
  }
};

const goTo = () => {
  internalDialog.value = false;

  if (window.AndroidFullScreen && typeof window.AndroidFullScreen.showSystemUI === 'function') {
    window.AndroidFullScreen.showSystemUI();
  }

  if (Capacitor.getPlatform() !== 'web') {
    StatusBar.setStyle({ style: Style.Light });
    StatusBar.setBackgroundColor({ color: '#ffffff' });
    // StatusBar.show();
  }
};
// Fonction pour basculer entre Konekte et Enskri
const switchToLogin = () => {
  isLogin.value = true;
};
const switchToRegister = () => {
  isLogin.value = false;
};

const login = async () => {
    loading2.value = true

  try {
    // Connexion à Firebase Auth
    const auth = getAuth();
    const result = await signInWithEmailAndPassword(auth, email.value, password.value);
    const user = result.user;

    // console.log('Utilisateur connecté:', user);
    // 🔥 Obtenir deviceId et country à chaque connexion
    const deviceId = await getDeviceId();
    const userCountry = await getUserCountry();
    // Vérification ou création du document utilisateur
    const userDocRef = doc(collection(db, "users"), user.uid);
    const userDoc = await getDoc(userDocRef);

    if (userDoc.exists()) {
      await updateDoc(userDocRef, {
        lastLogin: serverTimestamp(),
        isOnline: true,
        deviceId: deviceId, // 🔥 Mise à jour du deviceId
        country: userCountry, // 🔥 Mise à jour du pays
      });
    }
    // Réinitialiser les valeurs de email et password
    email.value = '';
    password.value = '';
    // Fermer le dialogue interne et rediriger
    // internalDialog.value = false;
    signWithEmail.value = false;
    internalDialog.value = false;
    loading2.value = false;

    if (window.AndroidFullScreen && typeof window.AndroidFullScreen.showSystemUI === 'function') {
      window.AndroidFullScreen.showSystemUI();
    }

     if (Capacitor.getPlatform() !== 'web') {
            StatusBar.setStyle({ style: Style.Light });
            StatusBar.setBackgroundColor({ color: '#ffffff' });
            // StatusBar.show();
    }
        
    router.push('/HomePage');
  } catch (error) {
    // Gestion des erreurs
    loading2.value = false;
    switch (error.code) {
      case "auth/invalid-email":
        errMsg.value = "Imel ou pa bon/ okenn chan pa ka vid";
        break;
      case "auth/user-not-found":
        errMsg.value = "Nou pa gen kont ak imel sa a.";
        break;
      case "auth/wrong-password":
        errMsg.value = "Modpas la pa bon/ okenn chan pa ka vid";
        break;
      default:
        errMsg.value = "Imel ou oubyen modpas ou pa bon/ okenn chan pa ka vid";
        break;
    }
  }
};
const getNonFromEmail = (email) => {
  const prefix = email.split("@")[0];
  const parts = prefix.split(".");

  if (parts.length > 1) {
    return {
      firstName: parts[0],
      lastName: parts[1]
    };
  } else {
    return {
      firstName: prefix,
      lastName: `${Math.floor(Math.random() * 10)}${String.fromCharCode(65 + Math.floor(Math.random() * 26))}${String.fromCharCode(65 + Math.floor(Math.random() * 26))}${Math.floor(Math.random() * 10)}`,
    };
  }
};

// Fonction pour sauvegarder les données utilisateur dans Firestore
const saveUserToFirestore = async (user, deviceId, userCountry) => {
  const userDocRef = doc(collection(db, "users"), user.uid);
  const userDoc = await getDoc(userDocRef);

  if (!userDoc.exists()) {
    const { firstName, lastName } = getNonFromEmail(user.email);

    await setDoc(userDocRef, {
      userId: user.uid,
      imel: user.email,
      created: serverTimestamp(),
      dateInscription: serverTimestamp(),
      lastLogin: serverTimestamp(),
      non: firstName,
      siyati: lastName,
      photoURL: user.photoURL || '',
      deviceId: deviceId, // ✅ ID unique du device
      country: userCountry, // ✅ Pays de l'utilisateur
      subscribedToAnnLi: false,
      notYet: true,
      translator: false,
      writer: false,
      admin: false,
      demandeResiliation: false,
      resiliationReasonWhy: "",
      credit: 5,
      allValidCorrections: 0,
      forLevelUser: 0,
      subscribedToWriters: [],
      usersSubscribedToMe: [],
      newUser: true,
      demandeSubscription: false,
      understoodValidation: false,
      understoodRead: false,
      understoodClassification: false,
      firstWinner: false,
      secondWinner: false,
      thirdWinner: false,
      nonValid: false,
      siyatiValid: false,
      imelValid: false,
      updateApp: true,
      updateAppMobile: false,
      authorizedCamera: false,
      premium: false,
      points: 10,
      fb: '',
      tk: '',
      x: '',
      yt: '',
      ig: '',
      shareEmailToReaders: 'non',
      isOnline: true,
      notificationAccepted: false,
      age: '',
      cible: '+18',
      shareLibrary: false,
      socialMedia: false,
      isAddedToList: false,
      fontSize: '18',
      lineHeight: '1.6',
      bgColor: 'white',
    });
  } else {
    await updateDoc(userDocRef, {
      lastLogin: serverTimestamp(),
      isOnline: true,
      deviceId: deviceId, // 🔥 Mise à jour du deviceId à chaque connexion
      country: userCountry, // 🔥 Mise à jour du pays à chaque connexion
    });
  }
};

const signInWithGoogle = async () => {
  loadingGoogle.value = true; // Démarrer le loading Google
  loading.value = false; // S'assurer que l'autre loading est désactivé

  const auth = getAuth();

  try {
    // Obtenir l'ID du device et le pays
    const deviceId = await getDeviceId();
    const userCountry = await getUserCountry();

    let user;
    if (Capacitor.isNativePlatform()) {
      const googleUser = await GoogleAuth.signIn();
      const idToken = googleUser.authentication.idToken;
      const credential = GoogleAuthProvider.credential(idToken);
      const result = await signInWithCredential(auth, credential);
      user = result.user;
    } else {
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);
      user = result.user;
    }

    // Vérifier si l'utilisateur existe déjà
    const userDocRef = doc(collection(db, "users"), user.uid);
    const userDoc = await getDoc(userDocRef);

    if (!userDoc.exists()) {
      // Nouvel utilisateur
      // Créer le nouveau compte avec deviceId et country
      await saveUserToFirestore(user, deviceId, userCountry);
    } else {
      // Utilisateur existant - mettre à jour les infos de connexion
      await updateDoc(userDocRef, {
        lastLogin: serverTimestamp(),
        isOnline: true,
        country: userCountry, // Mettre à jour le pays à chaque connexion
        deviceId: deviceId, // 🔥 Mise à jour du deviceId
      });
    }

    internalDialog.value = false;
    signWithEmail.value = false;
    loadingGoogle.value = false; // Arrêter le loading

    if (window.AndroidFullScreen && typeof window.AndroidFullScreen.showSystemUI === 'function') {
      window.AndroidFullScreen.showSystemUI();
    }

    if (Capacitor.getPlatform() !== 'web') {
      StatusBar.setStyle({ style: Style.Light });
      StatusBar.setBackgroundColor({ color: '#ffffff' });
      // StatusBar.show();
    }
    router.push({ path: '/HomePage' });

  } catch (error) {
    loadingGoogle.value = false; // Arrêter le loading
    // console.error("Erreur lors de l'authentification Google :", error);
    registrationMessage.value = "Yon erè rive pandan koneksyon an.";
  }
};

// Fonction d'inscription avec email et password
const register = async () => {
  loading3.value = true

  // Vérification des règles de mot de passe
  if (!rules.required(password.value)) {
    registrationMessage.value = rules.required(password.value);
    return;
  }
  if (!rules.min(password.value)) {
    registrationMessage.value = rules.min(password.value);
    return;
  }

  if (password.value !== confirmPassword.value) {
    registrationMessage.value = "Modpas yo pa menm";
    return;
  }

  try {

    // Obtenir l'ID du device et le pays
    const deviceId = await getDeviceId();
    const userCountry = await getUserCountry();

    // Vérification si l'e-mail est déjà utilisé
    const userCollectionRef = collection(db, 'users');
    const emailQuery = query(userCollectionRef, where("imel", "==", email.value));
    const emailSnapshot = await getDocs(emailQuery);

    if (!emailSnapshot.empty) {
      registrationMessage.value = "Imel sa a deja egziste nan sistèm nan.";
      return;
    }

    // Si tout est OK, créer l'utilisateur
    const auth = getAuth();
    const userCredential = await createUserWithEmailAndPassword(auth, email.value, password.value);
    const user = userCredential.user;

    // Créer le document utilisateur avec deviceId et country
    await setDoc(doc(collection(db, 'users'), user.uid), {
      userId: user.uid,
      imel: email.value,
      created: serverTimestamp(),
      dateInscription: serverTimestamp(),
      lastLogin: serverTimestamp(),
      non: non.value,
      siyati: siyati.value,
      photoURL: '',
      deviceId: deviceId, // ✅ ID unique du device
      country: userCountry, // ✅ Pays de l'utilisateur
      subscribedToAnnLi: false,
      notYet: true,
      translator: false,
      writer: false,
      admin: false,
      demandeResiliation: false,
      resiliationReasonWhy: false,
      credit: 5,
      allValidCorrections: 0,
      forLevelUser: 0,
      subscribedToWriters: [],
      usersSubscribedToMe: [],
      newUser: true,
      demandeSubscription: false,
      understoodValidation: false,
      understoodRead: false,
      understoodClassification: false,
      firstWinner: false,
      secondWinner: false,
      thirdWinner: false,
      nonValid: false,
      siyatiValid: false,
      imelValid: false,
      updateApp: true,
      updateAppMobile: false,
      authorizedCamera: false,
      premium: false,
      points: 10,
      fb: '',
      tk: '',
      x: '',
      yt: '',
      ig: '',
      shareEmailToReaders: 'non',
      isOnline: true,
      notificationAccepted: false,
      age: '',
      cible: '+18',
      shareLibrary: false,
      socialMedia: false,
      isAddedToList: false,
      fontSize: '18',
      lineHeight:'1.6',
      bgColor: 'white',
    });

    // Réinitialisation et redirection
    registrationMessage.value = "";
    signWithEmail.value = false;
    internalDialog.value = false;
    loading3.value = false;

    if (window.AndroidFullScreen && typeof window.AndroidFullScreen.showSystemUI === 'function') {
      window.AndroidFullScreen.showSystemUI();
    }

    if (Capacitor.getPlatform() !== 'web') {
      StatusBar.setStyle({ style: Style.Light });
      StatusBar.setBackgroundColor({ color: '#ffffff' });
      // StatusBar.show();
    }
    router.push('/HomePage');

  } catch (error) {
    loading3.value = false;

    switch (error.code) {
      case "auth/invalid-email":
        registrationMessage.value = "Imel ou pa bon/ okenn chan pa ka vid";
        break;
      case "auth/email-already-in-use":
        registrationMessage.value = "Imel sa a deja gen kont ki kreye.";
        break;
      case "auth/weak-password":
        registrationMessage.value = "Modpas la twò fèb.";
        break;
      default:
        registrationMessage.value = "Yon erè rive pandan enskripsyon an.";
        break;
    }
  }
};
// Navigation vers d'autres pages
const navigateTo = (route) => {
  signWithEmail.value = false;
  internalDialog.value = false; // Ferme le v-dialog
  router.push(route);
};
</script>

<style scoped>
.text-amber-darken-4 {
  margin-bottom: 20px;
  margin-left: 50%;
  transform: translateX(-50%);
  cursor: pointer;
  text-decoration: none;
}

.text-grey {
  color: grey;
}

.btn-amber-darken-4 {
  background-color: yellow;
  color: black;
}

.btn-grey {
  background-color: grey;
  color: white;
}





.glassmorphism-card {
  background: rgba(255, 255, 255, 0.25) !important;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items:center;
}

.handle-bar {
  width: 40px;
  height: 4px;
  background: rgba(255, 255, 255, 0.4);
  border-radius: 2px;
  margin: 0 auto 24px;
}

.icon-container {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #FF6F00, #FF8F00);
  border-radius: 50%;
  margin: 0 auto 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 32px rgba(255, 111, 0, 0.4);
}

.glass-title {
  color: #1a1a1a;
  font-size: 24px;
  font-weight: 800;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 8px;
}

.glass-subtitle {
  color: #4a5568;
  font-size: 16px;
  font-weight: 500;
}

.premium-btn-primary {
  background: linear-gradient(135deg, #FF6F00, #FF8F00) !important;
  box-shadow: 0 8px 24px rgba(255, 111, 0, 0.3);
  color: white !important;
  text-transform: none;
  font-weight: 700;
}

.premium-btn-secondary {
  background: rgba(255, 255, 255, 0.9) !important;
  border: 1px solid rgba(255, 255, 255, 0.5) !important;
  backdrop-filter: blur(10px);
  color: #1a1a1a !important;
  text-transform: none;
  font-weight: 600;
}

.glass-terms {
  font-size: 14px;
  color: #4a5568;
  line-height: 1.5;
}

.terms-link {
  color: #FF6F00;
  font-weight: 600;
  cursor: pointer;
  text-decoration: underline;
}




.glassmorphism-dialog {
  background: rgba(255, 255, 255, 0.25) !important;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  width: 100% !important;
  height: 100vh !important;
  border-radius: 0 !important;
}

.glassmorphism-close-btn {
  background: rgba(255, 255, 255, 0.2) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  backdrop-filter: blur(10px);
}

.glassmorphism-close-btn:hover {
  background: rgba(255, 255, 255, 0.3) !important;
  transform: scale(1.05);
}

.glassmorphism-content {
  height: 100vh;
  overflow-y: auto;
}

.glassmorphism-form {
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  padding: 16px;
  width: 100%;
  max-width: 400px;
}

.glassmorphism-title {
  color: white;
  font-size: 28px;
  font-weight: 800;
  text-align: center;
  margin: 0 0 32px 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.glassmorphism-fields {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.glassmorphism-field-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.glassmorphism-label {
  color: rgba(255, 255, 255, 0.9);
  font-size: 16px;
  font-weight: 600;
}

.glassmorphism-input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.glassmorphism-input {
  width: 100%;
  padding: 16px 50px 16px 16px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  background: rgba(255, 255, 255, 0.15);
  border-radius: 16px;
  color: white;
  font-size: 16px;
  font-weight: 500;
  backdrop-filter: blur(10px);
  outline: none;
  transition: all 0.3s ease;
}

.glassmorphism-input:focus {
  border: 1px solid rgba(255, 255, 255, 0.5);
  background: rgba(255, 255, 255, 0.2);
  box-shadow: 0 0 20px rgba(255, 255, 255, 0.1);
}

.glassmorphism-input::placeholder {
  color: rgba(255, 255, 255, 0.6);
}

.glassmorphism-clear-btn {
  position: absolute;
  right: 50px;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  font-size: 18px;
  z-index: 1;
  transition: color 0.3s ease;
}

.glassmorphism-clear-btn:hover {
  color: white;
}

.glassmorphism-input-icon {
  position: absolute;
  right: 16px;
  pointer-events: none;
}

.glassmorphism-visibility-btn {
  position: absolute;
  right: 16px;
  background: none;
  border: none;
  cursor: pointer;
  z-index: 1;
  transition: all 0.3s ease;
}

.glassmorphism-visibility-btn:hover {
  transform: scale(1.1);
}

.glassmorphism-error {
  color: #ffcdd2;
  text-align: center;
  font-size: 14px;
  margin: 0;
  padding: 12px;
  background: rgba(244, 67, 54, 0.2);
  border: 1px solid rgba(244, 67, 54, 0.3);
  border-radius: 12px;
  backdrop-filter: blur(10px);
}

.glassmorphism-btn-primary {
  background: linear-gradient(135deg, #FF6F00, #FF8F00) !important;
  color: white !important;
  box-shadow: 0 8px 24px rgba(255, 111, 0, 0.3);
  text-transform: none;
  font-weight: 700;
  font-size: 16px;
  border: none !important;
}

.glassmorphism-btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 32px rgba(255, 111, 0, 0.4);
}

.glassmorphism-btn-secondary {
  background: rgba(255, 255, 255, 0.2) !important;
  color: white !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  backdrop-filter: blur(10px);
  text-transform: none;
  font-weight: 600;
  font-size: 16px;
}

.glassmorphism-btn-secondary:hover {
  background: rgba(255, 255, 255, 0.3) !important;
  transform: translateY(-1px);
}

.glassmorphism-btn-tertiary {
  background: transparent !important;
  color: white !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  text-transform: none;
  font-weight: 600;
  font-size: 16px;
}

.glassmorphism-btn-tertiary:hover {
  background: rgba(255, 255, 255, 0.1) !important;
}

.glassmorphism-link {
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  text-align: center;
  text-decoration: underline;
  cursor: pointer;
  margin: 0;
  transition: color 0.3s ease;
}

.glassmorphism-link:hover {
  color: white;
}

.glassmorphism-link-text {
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  text-align: center;
  margin: 0;
}

/* Responsive */
@media (max-width: 768px) {
  .glassmorphism-form {
    padding: 12px;
  }

  .glassmorphism-title {
    font-size: 24px;
  }

  .glassmorphism-input {
    padding: 14px 45px 14px 14px;
    font-size: 15px;
  }
}
</style>
